/* ============================================================
   JuxtaCharge — section JS modules
   Each section registers init() + destroy() via window.JuxtaTheme
   so re-rendering in the theme editor reinitializes correctly.
   ============================================================ */
(function () {
  if (!window.JuxtaTheme) return;

  /* -------------------- Announcement bar -------------------- */
  JuxtaTheme.register('announcement-bar', {
    init(el) {
      // marquee behavior on mobile is CSS-only; nothing to wire here.
    },
    destroy() {}
  });

  /* -------------------- Header -------------------- */
  JuxtaTheme.register('header', {
    init(el) {
      // placeholder - nothing mandatory
    },
    destroy() {}
  });

  /* -------------------- Home hero -------------------- */
  JuxtaTheme.register('home-hero', {
    init() { /* CSS handles strip animation */ },
    destroy() {}
  });

  /* -------------------- Testimonials grid (homepage) -------------------- */
  JuxtaTheme.register('testimonials-grid', {
    init() {},
    destroy() {}
  });

  /* -------------------- Social collage (homepage) -------------------- */
  JuxtaTheme.register('social-collage', {
    init() { /* CSS marquee */ },
    destroy() {}
  });

  /* -------------------- Newsletter -------------------- */
  JuxtaTheme.register('newsletter', {
    init(el) {
      const form = el.querySelector('form');
      if (!form) return;
      const handler = (e) => {
        // Shopify will take over the POST; this is only a client-side nicety for instant feedback
        const successEl = el.querySelector('[data-newsletter-success]');
        if (successEl) { successEl.style.display = 'block'; }
      };
      form.addEventListener('submit', handler);
      el.__newsletterHandler = { form, handler };
    },
    destroy(el) {
      const h = el.__newsletterHandler;
      if (h) h.form.removeEventListener('submit', h.handler);
    }
  });

  /* -------------------- Marquee -------------------- */
  JuxtaTheme.register('juxta-marquee', { init() {}, destroy() {} });

  /* -------------------- Stats / media grid (mobile auto-scroll) -------------------- */
  JuxtaTheme.register('juxta-stats-media', {
    init(el) {
      const grid = el.querySelector('.stats-grid');
      if (!grid) return;
      let current = 0;
      let autoTimer;

      const cardWidth = () => {
        const card = grid.querySelector('.stat-card');
        return card ? card.offsetWidth + 12 : 0;
      };
      const goTo = (idx) => {
        const total = grid.querySelectorAll('.stat-card').length;
        current = (idx + total) % total;
        grid.scrollTo({ left: current * cardWidth(), behavior: 'smooth' });
      };
      const startAuto = () => { autoTimer = setInterval(() => goTo(current + 1), 6000); };
      const stopAuto = () => clearInterval(autoTimer);

      const mouseEnter = () => stopAuto();
      const mouseLeave = () => startAuto();
      const touchStart = () => stopAuto();
      const touchEnd = () => startAuto();

      const setupIfMobile = () => {
        stopAuto();
        current = 0;
        if (window.innerWidth <= 768) {
          grid.addEventListener('mouseenter', mouseEnter);
          grid.addEventListener('mouseleave', mouseLeave);
          grid.addEventListener('touchstart', touchStart, { passive: true });
          grid.addEventListener('touchend', touchEnd, { passive: true });
          startAuto();
        } else {
          grid.removeEventListener('mouseenter', mouseEnter);
          grid.removeEventListener('mouseleave', mouseLeave);
          grid.removeEventListener('touchstart', touchStart);
          grid.removeEventListener('touchend', touchEnd);
        }
      };
      setupIfMobile();
      window.addEventListener('resize', setupIfMobile);

      el.__statsMedia = { stopAuto, setupIfMobile, grid, mouseEnter, mouseLeave, touchStart, touchEnd };
    },
    destroy(el) {
      const s = el.__statsMedia;
      if (!s) return;
      s.stopAuto();
      s.grid.removeEventListener('mouseenter', s.mouseEnter);
      s.grid.removeEventListener('mouseleave', s.mouseLeave);
      s.grid.removeEventListener('touchstart', s.touchStart);
      s.grid.removeEventListener('touchend', s.touchEnd);
      window.removeEventListener('resize', s.setupIfMobile);
    }
  });

  /* -------------------- Testimonials carousel (product page) -------------------- */
  JuxtaTheme.register('juxta-testimonials-carousel', {
    init(el) {
      const track = el.querySelector('[data-testimonials-track]');
      const dots  = el.querySelectorAll('[data-testimonials-dot]');
      const prev  = el.querySelector('[data-testimonials-prev]');
      const next  = el.querySelector('[data-testimonials-next]');
      if (!track || dots.length === 0) return;

      const TOTAL = dots.length;
      let current = 0;
      let autoTimer;
      const autoplay = el.dataset.autoplay === 'true';
      const speed = parseInt(el.dataset.autoplaySpeed || '5', 10) * 1000;

      const cardWidth = () => {
        const c = track.querySelector('.tcard');
        return c ? c.offsetWidth + 20 : 320;
      };
      const goTo = (idx) => {
        current = (idx + TOTAL) % TOTAL;
        track.scrollTo({ left: current * cardWidth(), behavior: 'smooth' });
        dots.forEach((d, i) => d.classList.toggle('active', i === current));
      };
      const startAuto = () => { if (autoplay) autoTimer = setInterval(() => goTo(current + 1), speed); };
      const stopAuto = () => clearInterval(autoTimer);

      const onPrev = () => { stopAuto(); goTo(current - 1); startAuto(); };
      const onNext = () => { stopAuto(); goTo(current + 1); startAuto(); };
      if (prev) prev.addEventListener('click', onPrev);
      if (next) next.addEventListener('click', onNext);
      dots.forEach((dot, i) => dot.addEventListener('click', () => { stopAuto(); goTo(i); startAuto(); }));

      let scrollDebounce;
      const onScroll = () => {
        clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(() => {
          const idx = Math.round(track.scrollLeft / cardWidth());
          if (idx !== current) { current = idx % TOTAL; dots.forEach((d, i) => d.classList.toggle('active', i === current)); }
        }, 60);
      };
      track.addEventListener('scroll', onScroll);
      track.addEventListener('mouseenter', stopAuto);
      track.addEventListener('mouseleave', startAuto);
      startAuto();

      el.__tCarousel = { stopAuto, prev, next, onPrev, onNext, track, onScroll };
    },
    destroy(el) {
      const s = el.__tCarousel;
      if (!s) return;
      s.stopAuto();
      if (s.prev) s.prev.removeEventListener('click', s.onPrev);
      if (s.next) s.next.removeEventListener('click', s.onNext);
      s.track.removeEventListener('scroll', s.onScroll);
    }
  });

  /* -------------------- Compare table -------------------- */
  JuxtaTheme.register('juxta-compare', { init() {}, destroy() {} });

  /* -------------------- Guarantee -------------------- */
  JuxtaTheme.register('juxta-guarantee', { init() {}, destroy() {} });

  /* -------------------- Reviews (show more, helpful toast, image carousel, how-reviews-work) -------------------- */
  JuxtaTheme.register('juxta-reviews', {
    init(el) {
      // Show more
      const showBtn = el.querySelector('[data-reviews-show-more]');
      const more = el.querySelector('[data-reviews-more]');
      if (showBtn && more) {
        const onClick = () => { more.style.display = 'block'; showBtn.style.display = 'none'; };
        showBtn.addEventListener('click', onClick);
        el.__reviewsShowHandler = { showBtn, onClick };
      }

      // How reviews work toggle
      const howBlock = el.querySelector('[data-how-reviews]');
      const howBtn = howBlock && howBlock.querySelector('[data-how-reviews-btn]');
      if (howBtn && howBlock) {
        const onHow = () => howBlock.classList.toggle('open');
        howBtn.addEventListener('click', onHow);
        el.__reviewsHowHandler = { howBtn, onHow };
      }

      // Helpful/Report toast
      const toast = document.getElementById('AmzToast');
      const toastBtns = el.querySelectorAll('[data-toast-trigger]');
      let toastTimer;
      const onToast = () => {
        if (!toast) return;
        clearTimeout(toastTimer);
        toast.classList.add('show');
        toastTimer = setTimeout(() => toast.classList.remove('show'), 2500);
      };
      toastBtns.forEach((b) => b.addEventListener('click', onToast));
      el.__reviewsToastHandler = { toastBtns, onToast };

      // Image strip carousel
      const imgTrack = el.querySelector('[data-img-track]');
      const imgPrev = el.querySelector('[data-img-prev]');
      const imgNext = el.querySelector('[data-img-next]');
      if (imgTrack) {
        let current = 0;
        const slotWidth = () => {
          const s = imgTrack.querySelector('.amz-img-slot');
          return s ? s.offsetWidth + 8 : 98;
        };
        const total = () => imgTrack.querySelectorAll('.amz-img-slot').length;
        const goTo = (idx) => {
          current = Math.max(0, Math.min(idx, total() - 1));
          imgTrack.scrollTo({ left: current * slotWidth(), behavior: 'smooth' });
        };
        const onPrev = () => goTo(current - 1);
        const onNext = () => goTo(current + 1);
        if (imgPrev) imgPrev.addEventListener('click', onPrev);
        if (imgNext) imgNext.addEventListener('click', onNext);

        let autoTimer = setInterval(() => {
          let n = current + 1;
          if (n >= total()) n = 0;
          goTo(n);
        }, 5000);
        const stopAuto = () => clearInterval(autoTimer);
        const startAuto = () => { stopAuto(); autoTimer = setInterval(() => { let n = current + 1; if (n >= total()) n = 0; goTo(n); }, 5000); };
        imgTrack.addEventListener('mouseenter', stopAuto);
        imgTrack.addEventListener('mouseleave', startAuto);

        el.__reviewsImgHandler = { imgPrev, imgNext, imgTrack, onPrev, onNext, stopAuto, startAuto };
      }
    },
    destroy(el) {
      if (el.__reviewsShowHandler) el.__reviewsShowHandler.showBtn.removeEventListener('click', el.__reviewsShowHandler.onClick);
      if (el.__reviewsHowHandler)  el.__reviewsHowHandler.howBtn.removeEventListener('click', el.__reviewsHowHandler.onHow);
      if (el.__reviewsToastHandler) el.__reviewsToastHandler.toastBtns.forEach((b) => b.removeEventListener('click', el.__reviewsToastHandler.onToast));
      const h = el.__reviewsImgHandler;
      if (h) {
        h.stopAuto();
        if (h.imgPrev) h.imgPrev.removeEventListener('click', h.onPrev);
        if (h.imgNext) h.imgNext.removeEventListener('click', h.onNext);
        h.imgTrack.removeEventListener('mouseenter', h.stopAuto);
        h.imgTrack.removeEventListener('mouseleave', h.startAuto);
      }
    }
  });

  /* -------------------- FAQ accordion -------------------- */
  JuxtaTheme.register('juxta-faq', {
    init(el) {
      const oneOpen = el.dataset.oneOpen === 'true';
      const items = el.querySelectorAll('.faq-item');
      const handler = (btn) => (e) => {
        const item = btn.closest('.faq-item');
        const isOpen = item.classList.contains('open');
        if (oneOpen) items.forEach((i) => i.classList.remove('open'));
        if (!isOpen) item.classList.add('open');
        else if (!oneOpen) item.classList.remove('open');
      };
      const handlers = [];
      items.forEach((item) => {
        const btn = item.querySelector('.faq-q');
        if (!btn) return;
        const h = handler(btn);
        btn.addEventListener('click', h);
        handlers.push({ btn, h });
      });
      el.__faqHandlers = handlers;
    },
    destroy(el) {
      (el.__faqHandlers || []).forEach(({ btn, h }) => btn.removeEventListener('click', h));
    }
  });

  /* -------------------- Final CTA -------------------- */
  JuxtaTheme.register('juxta-final-cta', { init() {}, destroy() {} });

  /* -------------------- Footer -------------------- */
  JuxtaTheme.register('footer', { init() {}, destroy() {} });
})();
